import PropTypes from "prop-types";
import React, { Component } from "react";
import { FormSelect } from "react-bootstrap";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import FormLabel from "react-bootstrap/FormLabel";
import { FormattedMessage, injectIntl } from "react-intl";
import ObjectUtils, { coalesce } from "../../../utils/ObjectUtils";
import FundingAreaContainer from "../fundingArea/FundingAreaContainer";

const { findByObjectProp, opt } = ObjectUtils;

class SurveySettingsPanel extends Component {
  changeProperty(event) {
    this.props.changeProperty(event.target.name, event.target.value);
  }

  setNewValue(event, listOfValues) {
    let target = findByObjectProp(listOfValues, "id", event.target.value);
    if (target.id) {
      this.props.changeProperty(event.target.name, target);
    }
  }

  filterSelected(fundingArea, program, programInstance, project) {
    this.props.filterSelected(fundingArea, program, programInstance, project);
  }

  render() {
    const { surveyName, intl, fieldErrorMessages, templateLanguages, surveyLanguage } = this.props;
    let addProperty = {};
    if (fieldErrorMessages && fieldErrorMessages.surveyName) {
      addProperty.validationState = "error";
    }
    return (
      <>
        <FormGroup className="mb-3" {...addProperty}>
          <FormLabel>{intl.formatMessage({ id: "user.surveyBuilder.surveyTitle" })}</FormLabel>
          <FormControl
            name="surveyName"
            type="text"
            placeholder={intl.formatMessage({ id: "user.surveyBuilder.surveyTitlePlaceHolder" })}
            defaultValue={surveyName}
            onChange={this.changeProperty.bind(this)}
          />
        </FormGroup>
        <FormGroup  className="mb-3">
          <FormLabel>
            <FormattedMessage id="user.surveyBuilder.applicableFor" />
          </FormLabel>
          <FundingAreaContainer
            target="settings"
            preventProjectChoice
            filterSelected={(fundingArea, program, programInstance, project) =>
              this.filterSelected(fundingArea, program, programInstance, project)
            }
          />
        </FormGroup>
        <FormGroup  className="mb-3">
          <FormLabel>
            <FormattedMessage id="templateList.language" />
          </FormLabel>
          <FormSelect
            name="surveyLanguage"
            placeholder={intl.formatMessage({ id: "app.common.Language" })}
            onChange={(event) => this.setNewValue(event, templateLanguages)}
            defaultValue={coalesce(opt(surveyLanguage).id, "de")}
          >
            {templateLanguages.map((language, i) => {
              return (
                <option key={language.name + "-" + i} value={language.id}>
                  {language.name}
                </option>
              );
            })}
            ;
          </FormSelect>
        </FormGroup>
      </>
    );
  }
}

SurveySettingsPanel.propTypes = {
  isNew: PropTypes.bool,
  surveyName: PropTypes.string,
  fundingArea: PropTypes.object,
  program: PropTypes.object,
  programInstance: PropTypes.object,
  project: PropTypes.object,
  intl: PropTypes.object,
  fieldErrorMessages: PropTypes.object,
  changeProperty: PropTypes.func,
  filterSelected: PropTypes.func,
  surveyLanguage: PropTypes.object,
  templateLanguages: PropTypes.array,
  surveyActivationPeriod: PropTypes.object
};

export default injectIntl(SurveySettingsPanel);
